var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcPasswordless(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1505",
    "data-name": "Rectangle 1505",
    width: 24,
    height: 24,
    transform: "translate(16460.5 1488.001)",
    fill: "#003fb9"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_passwordless",
    transform: "translate(-16460.5 -1488.001)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "fingerprint-svgrepo-com_1_",
    "data-name": "fingerprint-svgrepo-com (1)",
    d: "M7.682,1.209a11.149,11.149,0,0,1,12,1,12.21,12.21,0,0,1,4,12c-.139.61-.39,1.139-1,1s-1.139-1.39-1-2a8.653,8.653,0,0,0-3-9,9.624,9.624,0,0,0-10-1c-.561.276-1.724.561-2,0S7.12,1.485,7.682,1.209Zm-3,3c.5.379,1.378,1.5,1,2-.793,1.043-1.711,1.722-2,3a50.785,50.785,0,0,1-1,5c-.206.591-1.409.206-2,0s-.206-.409,0-1a38.352,38.352,0,0,0,1-4,9.75,9.75,0,0,1,2-4C4.06,4.712,4.184,3.831,4.682,4.209Zm1,6c.7-3.087,2.848-5.7,6-6s6.737,2.1,8,5c.25.574-.426.75-1,1s-.75-.426-1-1c-.872-2-3.823-3.2-6-3s-3.514,1.868-4,4c-.263,1.157-.714,2.036-1,3-.178.6-.4,1.178-1,1s-1.178-.4-1-1C4.952,12.3,5.426,11.327,5.682,10.209Zm5-1a3.9,3.9,0,0,1,4,0,2.544,2.544,0,0,1,1,3c-.3,1.328-.61,2.7-1,4-.181.6-.4,1.181-1,1a2.05,2.05,0,0,1-1-2c.355-1.174.689-1.634,1-3,.084-.372-.685-.784-1-1a.859.859,0,0,0-1,0c-.519.349-.651-.481-1-1S10.162,9.558,10.682,9.209Zm8,3c.61.139,1.138.39,1,1a48.818,48.818,0,0,1-3,10c-.274.55-1.443,1.261-2,1s-.247-1.437,0-2a41.2,41.2,0,0,0,3-9C17.82,12.6,18.071,12.07,18.682,12.209Zm-8,1c.6.17.17.4,0,1a30.861,30.861,0,0,1-3,7c-.086.156.089.846,0,1-.324.518-.471.305-1,0s-1.287-.461-1-1c.082-.144-.079-.856,0-1,1.088-1.958,2.24-3.313,3-6A2.051,2.051,0,0,1,10.682,13.209Zm-6,3c.572.252,1.252.428,1,1-.329.751-.625,1.325-1,2-.311.53-1.462,1.3-2,1s-.286-1.455,0-2c.341-.615.7-1.316,1-2C3.933,15.636,4.109,15.958,4.682,16.209Zm17,0a2.05,2.05,0,0,1,1,2,31.483,31.483,0,0,1-1,3c-.218.587-.413,1.218-1,1s-1.218-.413-1-1c.44-1.186.634-2.717,1-4C20.853,16.607,21.08,16.037,21.682,16.209Zm-9,3c.576.242,1.242.423,1,1a31.491,31.491,0,0,1-2,3c-.189.368-.586.989-1,1s-.791-.643-1-1a.87.87,0,0,1,0-1,33.734,33.734,0,0,0,2-3C11.923,18.632,12.1,18.968,12.682,19.209Z",
    transform: "translate(16459.818 1487.792)",
    fill: "#003fb9",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPasswordless);
export default __webpack_public_path__ + "static/media/ic_passwordless.300e863ec056e82e5b412be6caa3285e.svg";
export { ForwardRef as ReactComponent };